export default "__VITE_ASSET__7bd6dcc3__"